import React, { useEffect, useMemo, useState } from "react";
import { toKeyYYYYMMDD } from "../../../utils/datesBR";
import css from "./W1EditarModal.module.css";

// Campos permitidos para edição rápida
const EDITABLE = [
  "data",
  "gerencia",
  "coordenador",
  "atividade",
  "unidade_de_medida",
  "quantidade",
  "tempo_do_intervalo",
  "os",
  "observacao",
  "nome_do_responsavel",
  "telefone_do_reponsavel",
];

export default function W1EditarModal({ open, initial, onClose, onSave }) {
  const init = useMemo(() => initial || {}, [initial]);
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm(
      EDITABLE.reduce((acc, k) => {
        acc[k] = init?.[k] ?? "";
        return acc;
      }, {})
    );
  }, [init]);

  if (!open) return null;

  function change(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

  function submit() {
    const patch = {};
    for (const k of EDITABLE) {
      const prev = init?.[k] ?? "";
      const cur = form?.[k] ?? "";
      if (String(prev) !== String(cur)) patch[k] = cur;
    }
    if (patch.data) patch.data = toKeyYYYYMMDD(patch.data);
    if (!Object.keys(patch).length) return onClose?.();
    onSave?.(patch);
  }

  return (
    <>
      <div className={css.overlay} onClick={onClose} />
      <div className={css.modal} role="dialog" aria-modal="true" aria-label="Editar Programação">
        <div className={css.card}>
          <header className={css.head}>
            <div>
              <div className={css.suptitle}>Editar Programação</div>
              <div className={css.title}>{init?.codigo_unico || "—"}</div>
            </div>
            <button className={css.close} onClick={onClose} title="Fechar">×</button>
          </header>

          <div className={css.form}>
            <div className={css.grid}>
              <label className={css.field}>
                <span>Data</span>
                <input
                  type="date"
                  name="data"
                  value={(toKeyYYYYMMDD(form.data) || "").slice(0, 10)}
                  onChange={change}
                />
              </label>

              <label className={css.field}>
                <span>Gerência</span>
                <input name="gerencia" value={form.gerencia || ""} onChange={change} />
              </label>

              <label className={css.field}>
                <span>Coordenador</span>
                <input name="coordenador" value={form.coordenador || ""} onChange={change} />
              </label>

              <label className={`${css.field} ${css.span2}`}>
                <span>Atividade</span>
                <input name="atividade" value={form.atividade || ""} onChange={change} />
              </label>

              <label className={css.field}>
                <span>Unidade</span>
                <input name="unidade_de_medida" value={form.unidade_de_medida || ""} onChange={change} />
              </label>

              <label className={css.field}>
                <span>Quantidade</span>
                <input
                  name="quantidade"
                  inputMode="numeric"
                  value={form.quantidade ?? ""}
                  onChange={change}
                />
              </label>

              <label className={css.field}>
                <span>Tempo do Intervalo (HH:mm)</span>
                <input name="tempo_do_intervalo" value={form.tempo_do_intervalo || ""} onChange={change} />
              </label>

              <label className={css.field}>
                <span>OS</span>
                <input name="os" value={form.os || ""} onChange={change} />
              </label>

              <label className={`${css.field} ${css.span2}`}>
                <span>Observação</span>
                <input name="observacao" value={form.observacao || ""} onChange={change} />
              </label>

              <label className={css.field}>
                <span>Nome do Responsável</span>
                <input name="nome_do_responsavel" value={form.nome_do_responsavel || ""} onChange={change} />
              </label>

              <label className={css.field}>
                <span>Telefone do Responsável</span>
                <input name="telefone_do_reponsavel" value={form.telefone_do_reponsavel || ""} onChange={change} />
              </label>
            </div>
          </div>

          <footer className={css.actions}>
            <button className={`${css.btn} ${css.ghost}`} onClick={onClose}>Cancelar</button>
            <button className={`${css.btn} ${css.primary}`} onClick={submit}>Salvar</button>
          </footer>
        </div>
      </div>
    </>
  );
}
